import { Tooltip } from 'antd';
import { FunctionComponent } from 'react';

import Icon from 'utils/icon';

interface InfoTooltipProps {
	title: string;
	style?: React.CSSProperties;
	customIcon?: React.ReactNode;
	color?: string;
}

const InfoTooltip: FunctionComponent<InfoTooltipProps> = ({ title, style, color, customIcon }) => {
	return (
		<Tooltip title={title} style={style} color={color}>
			<div style={{ marginInline: 7, display: 'flex' }}>{customIcon ? customIcon : <Icon name="info2" width={15} height={16} color="#888" />}</div>
		</Tooltip>
	);
};

export default InfoTooltip;
